export var EventEntity = {
    EntityName: "msevtmgt_event",
    EntitySetName: "msevtmgt_events",
    FieldName_PublicEventUrl: "msevtmgt_publiceventurl",
    FieldName_EventCancellationUrl: "msevtmgt_eventcancellationurl",
    FieldName_Name: "msevtmgt_name",
    FieldName_Id: "msevtmgt_eventid",
    FieldName_Checkin: "msevtmgt_eventcheckin"
};
